// extracted by mini-css-extract-plugin
export default {"pagination_container":"pagination_pagination_container__4fsMX"};